<div class="grid-container margin-top">

    <div class="grid-x grid-margin-x">
        <div class="cell small-12 medium-4 large-3 flex flex-align-items-center date-picker-cell">
            <label class="margin-right" for="dtpckrFromDate">From:</label>
            <common-date-picker [id]="'dtpckrFromDate'" [futureDateLimit]="dateFuture" (dateUpdated)="fromDateChange($event)"></common-date-picker>
        </div>
        <div class="cell small-12 medium-4 large-3 flex flex-align-items-center date-picker-cell">
            <label class="margin-right" for="dtpckrToDate">To:</label>
            <common-date-picker [id]="'dtpckrToDate'" [pastDateLimit]="datePast" (dateUpdated)="toDateChange($event)"></common-date-picker>
        </div>
    </div>
    <div class="grid-x grid-margin-x">
        <div class="cell small-6">
            <button (click)="generateReport()" class="button">
                Filter by Date
            </button>
        </div>
        <div class="cell small-6 text-right">
            <button (click)="downloadReport()" class="button">
                Download Report
            </button>
        </div>
    </div>
    <ag-grid-angular class="data-grid  fullpage" [gridOptions]="gridOptions" [rowData]="payments" (paginationChanged)="onGridPageChanged($event)" aria-label="Payment Open Items Report"></ag-grid-angular>
</div>